/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type GrantCreateKind = typeof GrantCreateKind[keyof typeof GrantCreateKind];


export const GrantCreateKind = {
  named: 'named',
  entity_scoped: 'entity_scoped',
  scheduler_default: 'scheduler_default',
  link: 'link',
} as const;
